import { __awaiter, __generator } from "tslib";
import { VoiceCommandSuggestionResult } from "@augloop-types/voice";
import * as AugLoopUtils from "../utils/AugLoopUtils";
import { ULS, TraceLevel, LogCategory } from "@1js/office-online-telemetry";
// Represents a will receive voice commands from AL.
var CommandSuggestionClient = /** @class */ (function () {
    function CommandSuggestionClient(alRuntimeManager, commandSuggestionManagerObserver, enableSetAnnotationsFromALVoiceClient) {
        var _this = this;
        this.initialized = false;
        this.commandSuggestionRequestToken = null;
        this.alRuntimeManager = alRuntimeManager;
        this.commandSuggestionManagerObserver = commandSuggestionManagerObserver;
        this.enableSetAnnotationsFromALVoiceClient =
            enableSetAnnotationsFromALVoiceClient;
        this.annotationObserver = {
            onAnnotationResult: function (op) {
                _this.onAnnotationResult(op);
            },
        };
    }
    // Activate command suggestion annotation.
    CommandSuggestionClient.prototype.initializeAsync = function (sessionTelemetry) {
        return __awaiter(this, void 0, void 0, function () {
            var annotationsActive, _a, err_1, msg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        annotationsActive = this.commandSuggestionRequestToken !== null;
                        ULS.sendTraceTag(0x1f1431c8 /* tag_5fdhi */, LogCategory.msoulscat_Wac_Dictation, TraceLevel.Info, "CommandSuggestionClient.initializeAsync - initialized: ".concat(this.initialized, ", annotationsActive: ").concat(annotationsActive));
                        if (!annotationsActive) return [3 /*break*/, 2];
                        // release stale annotations before trying to activate again
                        ULS.sendTraceTag(0x1f1431c7 /* tag_5fdhh */, LogCategory.msoulscat_Wac_Dictation, TraceLevel.Warning, "Releasing old annotations");
                        return [4 /*yield*/, this.uninitializeAsync()];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (sessionTelemetry)
                            this.sessionTelemetry = sessionTelemetry;
                        _b.label = 3;
                    case 3:
                        _b.trys.push([3, 5, , 6]);
                        _a = this;
                        return [4 /*yield*/, AugLoopUtils.activateAnnotationAsync(this.alRuntimeManager, VoiceCommandSuggestionResult.getTypeName(), this.annotationObserver, this.enableSetAnnotationsFromALVoiceClient)];
                    case 4:
                        _a.commandSuggestionRequestToken =
                            _b.sent();
                        this.initialized = true;
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _b.sent();
                        msg = "CommandSuggestionClient.initializeAsync - Activate Annotations - ".concat(err_1.message);
                        /**
                         * As long as AL Websocket timeout, AL will point client to a new Websocket. However, AL sub/pub keeps sending.
                         * the client "Timeout waiting for response" error message even client is dictation, which doesn't impact the dictation working.
                         * The issue needs to be fixed from infrastructural side,
                         * AL has an User Story to fix the error: https://office.visualstudio.com/DefaultCollection/GSX/_workitems/edit/4779001
                         */
                        if (msg.includes("Timeout waiting for response")) {
                            this.commandSuggestionManagerObserver.onWarning(err_1);
                        }
                        else {
                            this.commandSuggestionManagerObserver.onError(err_1);
                        }
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    // De-Activate voice commanding client.
    CommandSuggestionClient.prototype.uninitializeAsync = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var annotationsActive, err_2, msg;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        annotationsActive = this.commandSuggestionRequestToken !== null;
                        ULS.sendTraceTag(0x1f1431c6 /* tag_5fdhg */, LogCategory.msoulscat_Wac_Dictation, TraceLevel.Info, "CommandSuggestionClient.uninitializeAsync - initialized: ".concat(this.initialized, ", annotationsActive: ").concat(annotationsActive));
                        this.initialized = false;
                        if (!annotationsActive) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, AugLoopUtils.releaseAnnotations(this.alRuntimeManager, [
                                this.commandSuggestionRequestToken,
                            ])];
                    case 2:
                        _b.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _b.sent();
                        msg = "CommandSuggestionClient.uninitializeAsync - Release Annotations - ".concat(err_2.message);
                        (_a = this.sessionTelemetry) === null || _a === void 0 ? void 0 : _a.onAugloopError(msg);
                        ULS.sendTraceTag(0x1f1431c5 /* tag_5fdhf */, LogCategory.msoulscat_Wac_Dictation, TraceLevel.Error, "CommandSuggestionClient.uninitializeAsync - Release Annotations - Error message: " +
                            msg +
                            " - Error stack: " +
                            err_2.stack);
                        return [3 /*break*/, 4];
                    case 4:
                        this.commandSuggestionRequestToken = null;
                        _b.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    // Return an annotation observer implemented by us that app will use to forward annotations to us.
    CommandSuggestionClient.prototype.getAnnotationObserver = function () {
        return this.annotationObserver;
    };
    // Handle an annotation result.
    CommandSuggestionClient.prototype.onAnnotationResult = function (op) {
        var _this = this;
        var voiceCommandItems = AugLoopUtils.filterOperationByAnnotationTypeName(op, VoiceCommandSuggestionResult.getTypeName());
        voiceCommandItems.forEach(function (item) {
            _this.commandSuggestionManagerObserver.onCommandSuggestion(item.body);
        });
    };
    return CommandSuggestionClient;
}());
export { CommandSuggestionClient };
//# sourceMappingURL=CommandSuggestionClient.js.map